import {
  type MecImage,
  ProductImageType,
} from '@adapters/bigcommerce/types/product';

export const FIRST_IMAGE_SIZES = '(min-width: 768px) 854px, 100vw';
export const OTHER_IMAGE_SIZES = '(min-width: 768px) 423px, 100vw';
export const GALLERY_HERO_CANVAS_RATIO = 1;
export const GALLERY_DESKTOP_CELL_CANVAS_RATIO = 423 / 564;
export const GALLERY_MOBILE_CANVAS_RATIO = 390 / 464;
export const PDP_GALLERY_QA_COVER_RANGE_COOKIE = 'pdpImageFitCoverRange';

export type GalleryImageFitMode = 'cover' | 'contain';

/**
 * Type-based default fit for PDP gallery and zoom thumbnails (`LFS` → cover, `PRI`/`ALT` → contain).
 * `NEXT_PUBLIC_PDP_ADAPTIVE_IMAGE_FIT=false` rollback behavior is handled in ImageContainer.
 */
export function getGalleryImageFitFromImageType(
  image: MecImage
): GalleryImageFitMode {
  return image.imageType === ProductImageType.LFS ? 'cover' : 'contain';
}

export function getGalleryCanvasAspectRatio({
  isFirst,
  isNarrowViewport,
}: {
  isFirst: boolean;
  isNarrowViewport: boolean;
}): number {
  if (isNarrowViewport) {
    return GALLERY_MOBILE_CANVAS_RATIO;
  }

  return isFirst
    ? GALLERY_HERO_CANVAS_RATIO
    : GALLERY_DESKTOP_CELL_CANVAS_RATIO;
}
